<template>
    <div class="col-md-6">
        <div class="list-group">
            <div class="list-group-item list-group-item-info">
                {{ $t('breakdown.charges.cardTitle') }}
            </div>

            <div class="list-group-item" v-if="calculator.totals.merchantCharges.prepaid > 0">
                <strong>
                    {{ calculator.totals.merchantCharges.prepaid | formatMoney(carPackage.currency) }}
                </strong>
                {{ $t('breakdown.charges.merchants.car', {supplier: carPackage.vendor.shortName}) }}
            </div>
            <div class="list-group-item" v-if="calculator.totals.merchantCharges.postpaid > 0">
                <strong>
                    {{ calculator.totals.merchantCharges.postpaid | formatMoney(carPackage.currency) }}
                </strong>
                {{ $t('breakdown.charges.merchants.car_poa', {supplier: carPackage.vendor.shortName}) }}
                <div v-if="!carPackage.isInLocalCurrency" class="text-danger">
                    {{ $t('breakdown.charges.currencyConversionNotice', {currency: carPackage.currency.toUpperCase()})
                    }}
                </div>
            </div>

            <div class="list-group-item" v-if="calculator.totals.merchantCharges.agencia > 0">
                <strong>
                    {{ calculator.totals.merchantCharges.agencia | formatMoney(carPackage.currency) }}
                </strong>
                on Agencia Global's Merchant Account
                <div v-if="calculator.totals.merchantFee > 0"
                     class="text-danger"
                     id="agencia_merchant_fee_message">
                    {{ $t('breakdown.charges.merchantFeeNotice', {
                    merchantFee: (calculator.info.merchantFeeRate * 100).toFixed(0)
                    }) }}
                    {{calculator.totals.merchantFee | formatMoney(carPackage.currency )}}
                    <template v-if="calculator.totals.totalMerchantFeeTaxTotal > 0">
                        + {{ calculator.totals.totalMerchantFeeTaxTotal | formatMoney(carPackage.currency) }} tax
                    </template>
                    )
                </div>
            </div>
            <div class="list-group-item list-group-item-secondary">
                <strong>{{ calculator.totals.grandTotal | formatMoney(carPackage.currency) }}</strong>
                {{ $t('breakdown.charges.total') }}
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'priceBreakdownCharges',
        props: ['carPackage', 'calculator']
    };
</script>

<style scoped>

</style>